import React, { useEffect, useState } from "react";
import { Button, Grid, Paper, TextField, Typography } from "@material-ui/core";
import { api } from "../../api";
import { CashiersReconcilationList } from "./CashierReconcilationView/CashiersReconcilationList";
import { useCashiersStyles } from "./useCashiersStyles";
import { CashiersDetailList } from "./CashierReconcilationView/CashiersDetailList";
import { Formik, Form, ErrorMessage } from "formik";
import { Helmet } from "react-helmet-async";
import * as yup from "yup";
import moment from "moment";

export const CashierReconciliationMaster = () => {
  const classes = useCashiersStyles();
  const [userData, setUserData] = React.useState<any>();
  const [cashiersDetails, setCashiersDetails] = useState<Array<object>>([]);
  const [openDetails, setOpenDetails] = React.useState<boolean>(false);
  const [cashiersData, setCashiersData] = useState<Array<object>>([]);

  var currentDate = new Date();
  const to_date = moment(currentDate).format("YYYY-MM-DD");
  currentDate.setMonth(currentDate.getMonth() - 1);
  const from_date = moment(currentDate).format("YYYY-MM-DD");

  useEffect(() => {
    try {
      getCashierData(from_date, to_date);
    } catch (e) {
      console.log("error..", e);
    }
  }, []);

  const getCashierData = async (fromDate: any, toDate: any) => {
    const resultData = await api.get(
      `cashier-reconciliation?from_date=${fromDate}&to_date=${toDate}`
    );
    setCashiersData(resultData);
  };

  const showDetails = (details: any, userData: any) => {
    setUserData(userData);
    setCashiersDetails(details);
    setOpenDetails(true);
  };

  const closeDetails = () => {
    setOpenDetails(false);
  };

  return (
    <>
      <Helmet>
        <title>Cashier reconciliation</title>
      </Helmet>
      <div className={classes.root}>
        <Paper elevation={2} className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Formik
                enableReinitialize
                initialValues={{
                  fromDate: from_date,
                  toDate: to_date,
                }}
                validationSchema={yup.object().shape({
                  fromDate: yup.date().required("Required"),
                })}
                onSubmit={async (values) => {
                  getCashierData(values.fromDate, values.toDate);
                }}
              >
                {({ values, handleChange }) => (
                  <Form>
                    <Grid
                      container
                      direction="row"
                      spacing={3}
                      style={{
                        paddingLeft: "2em",
                        paddingRight: "2em",
                        paddingTop: "2em",
                      }}
                    >
                      <Grid item xs={3}>
                        <Grid container direction="column">
                          <Typography
                            style={{ textAlign: "left", fontWeight: "bold" }}
                          >
                            From Date
                          </Typography>
                          <TextField
                            type="date"
                            name="fromDate"
                            onChange={handleChange}
                            value={values.fromDate}
                          />
                          <ErrorMessage name="fromDate">
                            {(msg) => (
                              <div
                                className={classes.textFieldErrorMessageStyle}
                              >
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </Grid>
                      </Grid>

                      <Grid item xs={3}>
                        <Grid container direction="column">
                          <Typography
                            style={{ textAlign: "left", fontWeight: "bold" }}
                          >
                            To Date
                          </Typography>
                          <TextField
                            type="date"
                            name="toDate"
                            onChange={handleChange}
                            value={values.toDate}
                          />
                          <ErrorMessage name="toDate">
                            {(msg) => (
                              <div
                                className={classes.textFieldErrorMessageStyle}
                              >
                                {msg}
                              </div>
                            )}
                          </ErrorMessage>
                        </Grid>
                      </Grid>
                      <Grid item xs={3} sm="auto" style={{ paddingTop: "2em" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                        >
                          Show List
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ marginLeft: "2em", marginRight: "2em" }}
            >
              <CashiersReconcilationList
                cashiers={cashiersData}
                showDetails={showDetails}
              />
            </Grid>
            {openDetails ? (
              <Grid item xs={12}>
                <CashiersDetailList
                  cashiersDetails={cashiersDetails}
                  openDetails={openDetails}
                  closeDetails={closeDetails}
                  userData={userData}
                />
              </Grid>
            ) : null}
          </Grid>
        </Paper>
      </div>
    </>
  );
};
